import React, { useMemo } from "react";
import { Box, ICommand, Label } from "Application";
import { CellContext, ColumnDef } from "@tanstack/react-table";
import { MentorModel } from "../../Mentors/MentorModel";
import { MentorTable } from "../../Components/MentorTable";
import { TableData, ViewMentorDetailsButton } from "../../Mentors/MentorsView.styles";

interface PastMentorsProps {
    mentors: MentorModel[];
    onViewMentorDetailsCommand: ICommand;
}

export const PastMentorsTable: React.FC<PastMentorsProps> = ({ mentors, onViewMentorDetailsCommand }) => {
    const tableColumns = useMemo<ColumnDef<MentorModel>[]>(
        () => [
            {
                header: " ",
                columns: [
                    {
                        accessorKey: "firstName",
                        header: () => <Label fontStyle="h4">Mentor Name</Label>,
                        cell: (props: CellContext<MentorModel, any>) => <div>{props.row.original.formattedFullName}</div>,
                    },
                    {
                        accessorKey: "email",
                        header: () => <Label fontStyle="h4">Mentor email address</Label>,
                        cell: (info) => info.getValue(),
                    },
                    {
                        accessorKey: "phone",
                        header: () => <Label fontStyle="h4">Mentor Phone Number</Label>,
                        cell: (props: CellContext<MentorModel, any>) => <div>{props.row.original.phones}</div>,
                        enableSorting: false,
                    },
                    {
                        id: "mentordetails",
                        enableSorting: false,
                        cell: (props: CellContext<MentorModel, any>) => (
                            <Box>
                                <ViewMentorDetailsButton onClick={() => onViewMentorDetailsCommand.execute(props.row.original.id as string)}>
                                    View Mentor Details
                                </ViewMentorDetailsButton>
                            </Box>
                        ),
                    },
                    {
                        accessorKey: "lastActionDates",
                        header: () => <Label fontStyle="h4">Last Action</Label>,
                        cell: (props: CellContext<MentorModel, any>) => (
                            <Box flexBox flexDirection={"column"} width={"100%"} textAlign={"end"}>
                                <Label>{props.row.original.formattedLastActionDate}</Label>
                                <Label>{props.row.original.formattedActionName}</Label>
                            </Box>
                        ),
                    },
                ],
            },
        ],
        [],
    );

    return (
        <div className="scrollable-section">
            <TableData>
                <MentorTable data={mentors} columns={tableColumns} showSearchBox={true} searchBoxPlaceholderText="Keyword search" isSearchIcon={true} />
            </TableData>
        </div>
    );
};
